import { thankYouNoteConstants, apiConstants } from '../constants';
import url from '../../helpers/url';

export const saveThankYouNote = (form) => ({
    type: apiConstants.API,
    payload: {
        url: form.id ?
            url.recipientProgressThankYouNote.replace(':recipientId', form.recipientId).replace(':progressId', form.progressId).replace(':thankYouNoteId', form.id) :
            url.recipientProgressThankYouNotes.replace(':recipientId', form.recipientId).replace(':progressId', form.progressId),
        method: 'POST',
        body: form,
        request: () => ({ type: thankYouNoteConstants.SAVING_THANK_YOU_NOTE_REQUEST }),
        success: (data) => ({ type: thankYouNoteConstants.SAVING_THANK_YOU_NOTE_SUCCESS, data }),
        failure: (error) => ({ type: thankYouNoteConstants.SAVING_THANK_YOU_NOTE_FAILURE, error }),
        formatData: (data) => ({ form: { ...data[0] }}),
        progress: {
            success: { message: () => 'Saved Receipt.' }
        }
    }
});

export const deleteThankYouNote = ({ recipientId, progressId, thankYouNoteId }) => ({
    type: apiConstants.API,
    payload: {
        url: url.recipientProgressThankYouNote.replace(':recipientId', recipientId).replace(':progressId', progressId).replace(':thankYouNoteId', thankYouNoteId),
        method: 'DELETE',
        request: () => ({ type: thankYouNoteConstants.DELETE_THANK_YOU_NOTE_REQUEST }),
        success: (data) => ({ type: thankYouNoteConstants.DELETE_THANK_YOU_NOTE_SUCCESS, data }),
        failure: (error) => ({ type: thankYouNoteConstants.DELETE_THANK_YOU_NOTE_FAILURE, error }),
        formatData: () => (progressId),
        progress: {
            request: { message: () => 'Deleting thankYouNote' },
            success: { message: () => 'Deleted thankYouNote.' }
        }
    }
});

export const loadThankYouNotes = ({ recipientId, progressId }) => ({
    type: apiConstants.API,
    payload: {
        url: url.recipientProgressThankYouNotes.replace(':recipientId', recipientId).replace(':progressId', progressId),
        request: () => ({ type: thankYouNoteConstants.LOAD_THANK_YOU_NOTES_REQUEST }),
        success: (data) => ({ type: thankYouNoteConstants.LOAD_THANK_YOU_NOTES_SUCCESS, data }),
        failure: (error) => ({ type: thankYouNoteConstants.LOAD_THANK_YOU_NOTES_FAILURE, error })
    }
});



// WEBPACK FOOTER //
// ./src/redux/actions/thankYouNote.actions.js